import { styles } from './template.scss';
import { styles as commonStyles } from '../../../../assets/common.scss';
import { styles as colorHelpersStyles } from '../../../../assets/color-helpers.scss';
import { styles as widgetSharedStyles } from '../../../../assets/widget-shared.scss';
import { styles as flexboxHelpersStyles } from '../../../../assets/flexbox-helpers.scss';
import { styles as styleHelpers } from '../../../../assets/style-helpers.scss';
import { styles as textHelpersStyles } from '../../../../assets/text-helpers.scss';
import { FontSizes, FontWeights } from '../../../../types/common/types';

export const templateReconfigureAgentPanel = document.createElement('template');

templateReconfigureAgentPanel.innerHTML = `
  <style>${widgetSharedStyles}</style>
  <style>${colorHelpersStyles}</style>
  <style>${flexboxHelpersStyles}</style>
  <style>${styleHelpers}</style>
  <style>${textHelpersStyles}</style>
  <style>${commonStyles}</style>
  <style>${styles}</style>
  <div class='wrapper'>
    <div class='loading-container'>
      <gz-progress-spinner size='large'></gz-progress-spinner>
    </div>

    <div class='content-wrapper'>
      <div class='form-wrapper'>
        <gz-text id='reconfigure-agent-description' fontSize='${FontSizes.HEADING_6}'></gz-text>

        <gz-title id='reconfigure-agent-modules-subtitle' fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle pb-4'></gz-title>
        <gz-reconfigure-agent-type-form></gz-reconfigure-agent-type-form>

        <gz-package-modules-form class='pt-1'></gz-package-modules-form>

        <gz-info-box id='modules-requirements-box-info' class='info-box-style' severity='warning'></gz-info-box>

        <gz-package-scan-modes-form></gz-package-scan-modes-form>

        <gz-package-security-server-assignment-grid context='create'></gz-package-security-server-assignment-grid>

        <gz-title id='reconfigure-agent-scheduler-subtitle' fontSize='${FontSizes.HEADING_4}' fontWeight='${FontWeights.MEDIUM}' class='form-subtitle'></gz-title>
        <gz-reconfigure-agent-scheduler-form></gz-reconfigure-agent-scheduler-form>
      </div>
      <div class='bottom-buttons'>
        <gz-button id='save-button' disabled></gz-button>
        <div class='flex-auto'></div>
        <gz-button type='outline' color='secondary' id='cancel-button'></gz-button>
      </div>
    </div>
  </div>
`;
